namespace advisorop.components.widgets {
    
    export class CuAlertTaskController {
        $router;
        model: domains.IAlertLog = { advisors: [] };

        selSeverityType: domains.ILOV;
        selAlertType: domains.ILOV;
        selApplicationModule: domains.ILOV;
        selAccount: domains.IAccount;
        selInvestor: domains.IInvestor;
        selHousehold: domains.IHousehold;

        //lovs: Array<domains.ILOV> = [];
        severityAlerts: Array<domains.ILOV> = [];
        alertTypes: Array<domains.ILOV> = [];
        applicationModules: Array<domains.ILOV> = [];

        selectedAdvisor: domains.IAdvisor;
        advisorSelected: boolean;
        alertMessage: string;
        alertTypeTask: number = 5;
        advisors: Array<domains.IAdvisor> = [];
        laddaOperationInProgress: boolean = false;

        accounts: Array<domains.IAccount> = [];

        labelColWidth: number = 2;
        selectedInvestorHousehold: domains.ISearchInvestorHouseholdResults;
        
        static $inject = ["generalService", "identityService", "advisorService" , "$scope"];
        constructor(private generalService: services.GeneralService, private identityService: services.IdentityService, private advisorService: services.AdvisorService, private $scope: ng.IScope) {
        }

        validateAlertTaskForm(): boolean {
            let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["formTask"]);

            if (this.model.advisors.length <= 0) {
                formIsValid = false;
                toastr.error("You must select one or more advisors.");
            }

            if (!formIsValid)
                toastr.error("Account application is not complete. Please correct errors and try again");

            return formIsValid;
        };


        createAlertTask(): void {

            if (!this.validateAlertTaskForm()) return;

            this.laddaOperationInProgress = true;

            if (this.selSeverityType)
                this.model.severityId = this.selSeverityType.value;

            if (this.selAlertType)
                this.model.alertTypeId = this.selAlertType.value;
            
            if (this.selAccount)
                this.model.accounts = this.generalService.getAlertString(this.selAccount.id, this.selAccount.name);

            if (this.selectedInvestorHousehold)
            {
                if (this.selectedInvestorHousehold.entityType == 0) //investor                
                    this.model.investors = this.generalService.getAlertString(this.selectedInvestorHousehold.id, this.selectedInvestorHousehold.name);
                else
                    this.model.households = this.generalService.getAlertString(this.selectedInvestorHousehold.id, this.selectedInvestorHousehold.name);
            }
            
            //if (this.selApplicationModule)
            //    this.model.applicationId = this.selApplicationModule.value;
            this.model.applicationId = domains.ApplicationModules.UserTaskEntry;

            //console.log("Creating alert: ", this.model);

            this.generalService.createAlertOrTask(this.model)
                .then((data) => {
                   
                    toastr.success("Alert task added successfully.");
                    this.generalService.refreshAlertCounters();
                    this.clearInputs();
                })
                .catch((error) => {
                    toastr.error("Unable to add alert/task!");
                })
                .finally(() => {
                    this.laddaOperationInProgress = false;
                });
        };

        clearSelectedAdvisor(): void {
            this.selectedAdvisor = null;
            this.advisorSelected = false;
            
        };

        newAdvisorSelected(advisor: domains.IAdvisor): void {
            //if (advisor && advisor.id > 0) {
            //    this.selectedAdvisor = advisor;
            //    this.advisorSelected = true;
            //}
            var adv = this.model.advisors.filter((v, i, a) => {
                return v.id == advisor.id;
            });
            if (adv.length === 0) {
                this.model.advisors.push(advisor);
            }
            else {
                toastr.warning("Advisor already exists in the list of advisors.");
            }
        };

        removeAdvisorFromAdvisors(advisor: domains.IAdvisor): void {

            var ind = this.model.advisors.indexOf(advisor);
            if (ind >= 0)
                this.model.advisors.splice(ind, 1);
        };
        
        clearInputs(): void {
            this.model.alertMessage = "";
            this.selSeverityType = {};
            this.selAlertType = {};
            this.accounts = [];
            //this.selApplicationModule = {};
            this.model.advisors.splice(0);
            this.selAccount = {};
            this.selHousehold = {};
            this.selInvestor = {};
            this.selectedInvestorHousehold = null;       

            this.model.accounts = "";
            this.model.investors = "";
            this.model.households = "";
        };
       

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.severityAlerts = data.filter(v => v.lovType == domains.LovType.ALERT_SEVERITY
                        && v.value != domains.AlertSeverity.Informational);
                    this.alertTypes = data.filter(v => v.lovType == domains.LovType.ALERT_TYPE);
                    this.applicationModules = data.filter(v => v.lovType == domains.LovType.APPLICATION_MODULE);
                }, err => toastr.error("Error " + err.status + " " + err.data) );
        };

        getAccounts(): void {
            if (this.selectedInvestorHousehold)
            {
                this.accounts = [];
                if (this.selectedInvestorHousehold.entityType == 0)//0-investor
                {
                    this.advisorService.getAccountsByInvestor(this.selectedInvestorHousehold.id, 0, false, false, false, null)
                        .then((response) => {
                            this.accounts = response.data;
                        }, err => toastr.error("Error loading accounts" + err.status + " " + err.data));
                }
                else { //1-household
                    this.advisorService.getAccountsByHousehold(this.selectedInvestorHousehold.id, 0, false, false, false, null)
                        .then((response) => {
                            this.accounts = response.data;
                        }, err => toastr.error("Error loading accounts" + err.status + " " + err.data));
                }
            }
        }

        

        searchInvestorHouseholds(term: string): ng.IPromise<{}>  {
            this.accounts = [];
            return this.advisorService.searchInvestorsHouseholds(term).then((response) => {
                return response.data;
            });
        }

        onSelectInvestorHouseholds(i, m, l, e): void {
            //console.log("odabrano", i);
            this.getAccounts();
        }


        $onInit() {
            this.loadLovs();
        };


        $routerOnActivate(next, previous) {
        };
    }

    class CuAlertTask implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<",
            };
            this.controller = CuAlertTaskController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/cu-alert-task.html';
        }
    }
    angular.module(Constants.APP).component("cuAlertTask", new CuAlertTask());
}